<!-- 资讯百科 -->
<template>
  <div class="home">
    <div>
      <CollapsiblePanel
        title="首页"
        :arrow-images="[arrowRight]"
        :static-arrow="true"
        @click.native="goToHome"
      />
      <CollapsiblePanel
        title="房源列表"
        :arrow-images="[arrowRight]"
        :static-arrow="true"
        @click.native="goToPropertie"
      />
      <CollapsiblePanel
        title="热门项目"
        :arrow-images="[arrowRight, arrowBottom]"
        :static-arrow="false"
      >
        <template #content>
          <ul>
            <li @click="goToImmigration">移民项目</li>
            <li>留学教育</li>
            <li>境外生活</li>
            <li>资讯百科</li>
          </ul>
        </template>
      </CollapsiblePanel>
    </div>

    <div class="company-info">
      <img src="../assets/littleLogo.png" alt="" />
      <h1>
        公司作为专业从事企业级移动互联平台产品研发的高新技术企业，
        致力于将移动互联世界的理念、技术和用户体验引入2B领域。
      </h1>
    </div>
  </div>
</template>

<script>
import CollapsiblePanel from "../components/CollapsiblePanel.vue";
export default {
  name: "Menu",
  components: {
    CollapsiblePanel,
  },
  data() {
    return {
      arrowRight: require("../assets/arrowRight.png"),
      arrowBottom: require("../assets/arrowBottom1.png"),
    };
  },
  methods: {
    goToHome() {
      this.$router.push("/");
    },
    goToPropertie() {
      this.$router.push("/Properties");
    },
    goToImmigration() {
      this.$router.push("/news/immigration");
    },
  },
};
</script>

<style scoped lang="less">
.content {
  margin: 0 auto;
  width: 100%;
  max-width: 75rem;
}
.home {
  height: calc(100vh - 65px);
  padding: 0 32px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1; /* 占据剩余空间 */
  position: relative;
  .company-info {
    display: flex;
    margin-top: auto; /* 把它推到最底部 */
    padding-bottom: 45px; /* 距离底部 45px */
    flex-direction: column;
    img {
      width: 187px;
      height: 32px;
      margin-bottom: 25px;
    }
    h1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      line-height: 17px;
      text-align: left;
    }
  }
}
</style>
